import React, { useEffect, useState } from 'react';
import { Alert, Spinner } from 'react-bootstrap';
import dayjs from 'dayjs';
import { externalCalendarEventApi } from '@/_services/api/calendarIntegration/externalCalendarEvents';
import { calendarIntegrationUtils } from '@/components/Features/CalendarIntegration/utils/utils';
import ComponentErrorBoundary from '@/Layouts/ComponentErrorBoundary';

const Component = React.memo(({ task }) => {
    const [externalEvent, setExternalEvent] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let isMounted = true;

        const fetchExternalEvent = async () => {
            const originalId = task?.externalEventOriginalId;
            setExternalEvent(null);
            if (!originalId) {
                return;
            }

            try {
                setLoading(true);
                const response = await externalCalendarEventApi.getEventByOriginalId(originalId);
                if (isMounted) {
                    setExternalEvent(response);
                }
            } catch (error) {
                if (isMounted) {
                    setExternalEvent(null);
                }
            } finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        };

        fetchExternalEvent();

        return () => {
            isMounted = false;
        };
    }, [task?.externalEventOriginalId]);

    const taskUpdatedAt = task?.externalCalendarUpdatedAt ? dayjs(task.externalCalendarUpdatedAt) : null;
    const externalUpdatedAt = externalEvent?.updatedAt ? dayjs(externalEvent.updatedAt) : null;
    console.log({
        taskUpdatedAt,
        externalUpdatedAt,
    });
    const isOutOfSync =
        Boolean(task?.externalEventOriginalId) &&
        Boolean(taskUpdatedAt) &&
        Boolean(externalUpdatedAt) &&
        !taskUpdatedAt.isSame(externalUpdatedAt);

    if (!task?.externalEventOriginalId || !isOutOfSync) {
        return null;
    }

    return (
        <Alert variant="warning" className="mb-3">
            <div className="d-flex align-items-center justify-content-between flex-wrap" style={{ gap: 12 }}>
                <div>
                    <strong>
                        {calendarIntegrationUtils.formatProviderName(externalEvent?.calendarProvider || '')}
                    </strong>
                    <span className="ml-1">Event may be out of sync.</span>
                </div>
                {loading ? <Spinner animation="border" size="sm" /> : null}
            </div>
            <div>
                Last Synced at: <strong>{taskUpdatedAt?.format('MMM D, YYYY h:mm A')}</strong>
            </div>
        </Alert>
    );
});

const TaskExternalCalendarSyncAlert = (props) => (
    <ComponentErrorBoundary componentErrorMessage={''}>
        <Component {...props} />
    </ComponentErrorBoundary>
);

export default TaskExternalCalendarSyncAlert;
